import CustomFilterText from "../unit/CustomFilterText";
import FilterAgency from "../unit/FilterAgency";
import FilterAmountOriginalPrincipal from "../unit/FilterAmountOriginalPrincipal";
import FilterAmountPrincipal from "../unit/FilterAmountPrincipal";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterDecision from "../unit/FilterDecision";
import FilterLoanShortStatus from "../unit/FilterLoanShortStatus";
import FilterNoteDate from "../unit/FilterNoteDate";
import FilterProduct from "../unit/FilterProduct";

const counselorsLoansFilters = [
  // <CustomFilterText
  //   label="Referral"
  //   source="counselor_agency"
  //   defaultValue=""
  //   alwaysOn
  // />,
  <FilterAgency
    label="Referral Source"
    source="counselor_agency"
    defaultValue=""
    alwaysOn
  />,
  // <CustomFilterText
  //   label="Counselor Name"
  //   source="counselor_name"
  //   defaultValue=""
  //   alwaysOn
  // />,
  <CustomFilterText label="App #" source="iId" defaultValue="" />,
  <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
  <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterNoteDate label="Note Date" source="limitNoteDate" before="and" />,
  <FilterProduct label="Product" source="sProductName" before="and" />,
  <FilterAmountOriginalPrincipal
    label="Original Principal Amount"
    source="originalnoteamount"
    before="and"
  />,
  <FilterAmountPrincipal
    label="Remaining Principal Amount"
    source="activeprincipalbalance"
    before="and"
  />,
  <FilterLoanShortStatus label="Status" source="curStatus" before="and" />,
];

export default counselorsLoansFilters;
